import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
(function(IBrandPromoCollection) {
    (function(Type) {
        /**
     * Catalog-level promotions based on certain tiers of per-order spending. For example,
     * if you spend more than $50 on a particular brand in a single order, you will get a
     * $5 discount. It is possible to have multiple tiers based on price. However, the
     * important distinction here is that these promos are Catalog-level.
     * TODO(noah): consider renaming this CATALOG instead of TIERED
     */ Type["TIERED"] = "TIERED";
        /**
     * Used for abandoned cart promotion experiment. No longer in use.
     * TODO(noah): consider actually cleaning this up since it has not been used for almost a year (#32836)
     * @deprecated
     */ Type["RETAILER_SPECIFIC"] = "RETAILER_SPECIFIC";
        /**
     * Product-level promotion where promotions are attached to a given product.
     */ Type["PRODUCT"] = "PRODUCT";
    })(IBrandPromoCollection.Type || (IBrandPromoCollection.Type = {}));
    (function(Program) {
        Program["PROGRAM_UNKNOWN"] = "PROGRAM_UNKNOWN";
        /**
     * Promotion created and funded by the brand via the Brand Promotions portal.
     */ Program["BRAND_PROMOTION"] = "BRAND_PROMOTION";
        /**
     * Promotion program based on loyalty relations between a single brand and retailer.
     * See the MVP PRD for more details:
     * https:www.notion.so/faire/MVP-Volume-discounts-a802a4dc20eb4c869560b9faeaeedc64
     * @deprecated
     */ Program["RETAILER_BRAND_LOYALTY"] = "RETAILER_BRAND_LOYALTY";
        /**
     * Sponsored Discount for Opening Orders for Faire Direct Rewards Brands
     * https:www.notion.so/faire/Faire-Direct-Rewards-Discount-FDR-Discount-8dc513866bf243a69c996b8c7ca378d9
     */ Program["FAIRE_DIRECT_REWARDS"] = "FAIRE_DIRECT_REWARDS";
    })(IBrandPromoCollection.Program || (IBrandPromoCollection.Program = {}));
    (function(State) {
        State["ACTIVE"] = "ACTIVE";
        State["EXPIRED"] = "EXPIRED";
        State["CANCELED"] = "CANCELED";
        State["PENDING"] = "PENDING";
        State["DELETED"] = "DELETED";
    })(IBrandPromoCollection.State || (IBrandPromoCollection.State = {}));
    (function(RetailerAudience) {
        /**
     * The promotion will only be shown to retailers who have not yet had one complete order with this brand.
     */ RetailerAudience["NEW_RETAILERS"] = "NEW_RETAILERS";
        /**
     * The promotion will only be shown to retailers that have had at least one un-cancelled order with this brand.
     */ RetailerAudience["EXISTING_RETAILERS"] = "EXISTING_RETAILERS";
        /**
     * The promotion will be shown to all retailers.
     */ RetailerAudience["ALL_RETAILERS"] = "ALL_RETAILERS";
        /**
     * Used for abandoned cart promotion experiment. No longer in use.
     * TODO(noah): consider actually cleaning this up since it has not been used for almost a year (#32836)
     * @deprecated
     */ RetailerAudience["SPECIFIC_RETAILER"] = "SPECIFIC_RETAILER";
    })(IBrandPromoCollection.RetailerAudience || (IBrandPromoCollection.RetailerAudience = {}));
    (function(ProductShipAvailability) {
        ProductShipAvailability["ALL_PRODUCTS"] = "ALL_PRODUCTS";
        /**
     * Only immediate products will be counted towards minimum spend requirement and will be discounted
     * Use this instead of ONLY_IMMEDIATE_PRODUCTS_DISCOUNTED if you don't want preorder items to be counted for
     * minimum spend requirement
     */ ProductShipAvailability["ONLY_IMMEDIATE_PRODUCTS"] = "ONLY_IMMEDIATE_PRODUCTS";
        /**
     * All products are counted towards minimum spend requirement, but only immediate products will be discounted
     */ ProductShipAvailability["ONLY_IMMEDIATE_PRODUCTS_DISCOUNTED"] = "ONLY_IMMEDIATE_PRODUCTS_DISCOUNTED";
    })(IBrandPromoCollection.ProductShipAvailability || (IBrandPromoCollection.ProductShipAvailability = {}));
    IBrandPromoCollection.build = function(partial) {
        return _object_spread({
            promos: []
        }, partial !== null && partial !== void 0 ? partial : {});
    };
})(IBrandPromoCollection || (IBrandPromoCollection = {}));
export var IBrandPromoCollection;
